import { useLoggerStore } from '@/store/logger'
import type { PopupEvent } from '@/types/logger.types'

export type PopupShowOptions = {
    trigger: string
    manual?: boolean
    variant?: string
}

const triggers = new Map<string, string>()

export function usePopupAnalytics(popupId: string) {
    const loggerStore = useLoggerStore()

    function log(eventName: PopupEvent, dimension3: string) {
        loggerStore.logEvent({
            event: 'custom_event',
            eventName,
            dimension1: popupId,
            dimension2: triggers.get(popupId) || '',
            dimension3,
        })
    }

    return {
        shown({ trigger, manual, variant }: PopupShowOptions) {
            triggers.set(popupId, `${manual ? 'manual' : 'auto'}:${trigger}`)
            log('popup_show', variant || '')
        },
        clicked(button: string) {
            log('popup_click', button)
        },
        closed(reason: string) {
            log('popup_close', reason)
            triggers.delete(popupId)
        },
    }
}
